import React from 'react';

interface DashboardErrorBannerProps {
  message: string;
}

export const DashboardErrorBanner: React.FC<DashboardErrorBannerProps> = ({ message }) => (
  <div className="glass-strong bg-gradient-to-r from-red-50/80 to-rose-50/80 dark:from-red-900/30 dark:to-rose-900/30 border border-red-200/50 dark:border-red-800/50 rounded-2xl p-4 shadow-lg animate-slide-up">
    <div className="flex items-center gap-3 text-red-700 dark:text-red-300">
      <span className="text-2xl">⚠️</span>
      <span className="font-semibold">{message}</span>
    </div>
  </div>
);
